<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.40918 5H35.4092V35H5.40918V5ZM24.1595 18.75L33.5338 27.4999L33.534 33.125L9.78479 33.125L24.1595 18.75ZM13.5342 16.25C15.2601 16.25 16.6592 14.8509 16.6592 13.125C16.6592 11.3991 15.2601 10 13.5342 10C11.8083 10 10.4092 11.3991 10.4092 13.125C10.4092 14.8509 11.8083 16.25 13.5342 16.25Z"
      class="fill-current"
    />
  </svg>
</template>
